
import axiosApi from "../../Utils/axiosApi";
import { mockRooms, mockStays } from "../data/mockOccupancy";

let rooms = mockRooms.map((x) => ({ ...x }));
let stays = mockStays.map((x) => ({ ...x }));

const clone = (x) =>
  Promise.resolve(JSON.parse(JSON.stringify(x)));

export const occupancyService = {
  // Fetch occupancy data from backend
  async getOccupancy(
    hostelId = null,
    startDate = null,
    endDate = null
  ) {
    try {
      const response = await axiosApi.post(
        "/hostel/getOccupancy",
        {
          hostelSearchCriteria: {
            hostelIds: hostelId ? [hostelId] : [],
            searchCheckInDate: startDate,
            searchCheckOutDate: endDate,
          },
        }
      );

      const data = response.data || {};

      // Map backend room fields to frontend fields
      const apiRooms = (data.rooms || []).map((room, index) => ({
        ...room,

        // Use a stable fallback only for frontend rendering.
        id:
          room.id ??
          room.roomRowId ??
          `room-${index}`,

        number:
          room.roomNumber ||
          "Room number unavailable",

        type:
          room.roomType ||
          "Unknown room type",

        capacity: Number(room.roomCapacity ?? 0),

        status: room.status || "AVAILABLE",
      }));

      // Map backend stay fields to frontend fields
      const apiStays = (data.stays || []).map((stay, index) => ({
        ...stay,

        id:
          stay.id ??
          stay.stayId ??
          `stay-${index}`,

        tenantName:
          stay.tenantName ||
          "Guest name unavailable",

        phone: stay.mobileNumber || "",

        checkIn: stay.checkIn
          ? stay.checkIn.slice(0, 10)
          : "",

        checkOut: stay.checkOut
          ? stay.checkOut.slice(0, 10)
          : "",

        guests: Number(stay.guestCount ?? 1),

        notes: stay.remarks || "",

        roomNumber: stay.roomNumber || "",

        type: stay.roomType || "",

        // Keep the backend room reference.
        roomId: stay.roomId ?? "",
      }));

      return {
        ...data,
        rooms: apiRooms,
        stays: apiStays,

        summary: data.summary || {
          totalRooms: apiRooms.length,
          occupiedRooms: 0,
          availableRooms: apiRooms.length,
        },
      };
    } catch (error) {
      console.error(
        "Error fetching occupancy:",
        error.response?.data || error
      );

      throw new Error(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch occupancy details"
      );
    }
  },

  // Update an existing stay (currently mock data)
  async updateStay(v) {
  const operation = String(v.operation || "").toUpperCase();

  if (operation === "MOVE") {
    const response = await axiosApi.post(
      "/stayServiceBooking/updateRoomBooking",
      {
        stayServiceBookingId: v.stayId ?? v.id,
        roomNumber: v.targetRoomNumber ?? v.roomNumber,
        roomType: v.targetRoomType ?? v.type,
      }
    );

    return response.data;
  }

  // Keep existing backend update API here when available.
  throw new Error("Normal stay update API is not configured.");
},
  // Create a stay (currently mock data)
  async createStay(v) {
    const s = {
      ...v,
      id: v.id || `stay-${Date.now()}`,
    };

    stays = [...stays, s];

    return clone(s);
  },

  // Delete a stay (currently mock data)
  async deleteStay(id) {
    stays = stays.filter((s) => s.id !== id);

    return clone({ success: true });
  },

  // Update a room (currently mock data)
  async updateRoom(v) {
    rooms = rooms.map((r) =>
      r.id === v.id ? { ...r, ...v } : r
    );

    return clone(rooms.find((r) => r.id === v.id) || v);
  },
};
